import CampaignHead from '@components/campaign-head/campaign-head.component'
import { withTransaction } from '@elastic/apm-rum-react'
import {
  Campaign,
  FitRequirements,
  HubCampaignsService,
  LogService,
  NavigationSingleLayout,
  onUserChange,
  User,
  UserInDetails,
} from '@hub/shared'
import { SqLoader } from '@squidit/react-css'
import ModalIncompleteProfileComponent from '@src/components/modal-incomplete-profile/modal-incomplete-profile.component'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { SubscriptionLike } from 'rxjs'
import CampaignFooter from './components/campaign-footer/campaign-footer.component'
import PreRecruitmentOpportunity from './components/pre-recruitment-opportunity/pre-recruitment-opportunity.component'
import PreRecruitment from './components/pre-recruitment/pre-recruitment.component'
import './summary.page.scoped.scss'
import './summary.page.scss'

const SummaryPageComponent = (props: any) => {
  const onUserChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const logService = useMemo(() => new LogService(), [])
  const hubCampaignsService = useMemo(() => new HubCampaignsService(), [])
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState<User | null>(null)
  const { idCampaign } = useParams<{ idCampaign: string }>()
  const navigate = useNavigate()
  const [registerRequirements, setRegisterRequirements] = useState(false)
  const [campaignObject, setCampaign] = useState<{
    campaign: Campaign
    fitRequirements?: FitRequirements
    users: UserInDetails[]
    hasVacancies?: boolean
  } | null>(null)
  const [userSelected, setUserSelected] = useState({} as UserInDetails)

  logService.init('Campaign Summary Page')

  const getCampaignObject = useCallback(() => {
    if (!loading && user?.squidId && idCampaign) {
      setLoading(true)
      hubCampaignsService
        .getCampaignDetail(idCampaign)
        .then((e) => {
          if (!e?.campaign) {
            history.pushState({}, '', '/error')
          }
          setCampaign(e)
        })
        .catch((error) => {
          logService.error({ message: 'Failed to get campaign with id ' + idCampaign, error })
          history.pushState({}, '', '/error')
        })
        .finally(() => {
          setLoading(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hubCampaignsService, logService, idCampaign, user])

  useEffect(() => {
    onUserChangeSubscription.current = onUserChange.subscribe(async (userChanged: User) => {
      if (userChanged?.squidId) {
        setUser(userChanged)
      }
    })
    return () => {
      onUserChangeSubscription.current?.unsubscribe()
    }
  }, [onUserChangeSubscription])

  useEffect(() => {
    getCampaignObject()
  }, [idCampaign, getCampaignObject])

  let content = <PreRecruitment campaign={campaignObject?.campaign} userSelected={userSelected} />
  if (campaignObject?.campaign?.activation?.suggestion && userSelected?.status !== 'inContact') {
    content = (
      <PreRecruitmentOpportunity
        campaign={campaignObject?.campaign}
        fitRequirements={campaignObject?.fitRequirements}
        userSelected={userSelected}
        onChange={(value) => setRegisterRequirements(value)}
      />
    )
  }

  if (loading) {
    return (
      <div className="summary-page loader-wrapper box">
        <SqLoader size="big" />
      </div>
    )
  }

  return (
    <div>
      <NavigationSingleLayout
        className="summary-page"
        backButton
        stickyFooter
        onReferrerFalseUrlBackButton="/campaigns"
        header={<CampaignHead campaign={campaignObject?.campaign} mode="summary" user={userSelected} />}
      >
        {content}
        <CampaignFooter
          campaignObject={campaignObject}
          user={user}
          registerRequirements={registerRequirements}
          onChange={(value) => setUserSelected(value)}
          updateCampaignObject={() => getCampaignObject()}
        />
      </NavigationSingleLayout>
      <ModalIncompleteProfileComponent />
    </div>
  )
}

export default withTransaction('SummaryPageComponent', 'component')(SummaryPageComponent)
